import { type Colors, colors } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const strategyTranslation = (strategy: PerformanceReviewerStrategiesStrategyEnum) => {
  switch (strategy) {
    case 'self':
      return i18n.t('performance_process.reviews.review_type_questions_self_review')

    case 'manager':
      return i18n.t('performance_process.reviews.review_type_questions_manager')

    case 'direct_reports':
      return i18n.t('performance_process.reviews.review_type_questions_direct_report')

    case 'peers':
      return i18n.t('performance_process.reviews.review_type_questions_peer')

    default:
      return i18n.t('performance_process.reviews.secondary_title_empty')
  }
}

export const strategyColor = (
  strategy: PerformanceReviewerStrategiesStrategyEnum
): [Colors, string] => {
  switch (strategy) {
    case 'self':
      return ['malibu1000', colors.malibu1000]

    case 'manager':
      return ['purple1000', colors.purple1000]

    case 'direct_reports':
      return ['champagne1000', colors.champagne1000]

    case 'peers':
      return ['lime1000', colors.lime1000]

    default:
      return ['grey800', colors.grey800]
  }
}

export const orderStrategies = (
  strategies: PerformanceReviewerStrategiesStrategyEnum[] | string[]
): PerformanceReviewerStrategiesStrategyEnum[] => {
  const order: PerformanceReviewerStrategiesStrategyEnum[] = [
    'self',
    'manager',
    'direct_reports',
    'peers',
  ]

  const orderedStrategies = order.filter((strategy) => strategies.includes(strategy))
  return orderedStrategies
}

export const strategyChartColor = (strategy: PerformanceReviewerStrategiesStrategyEnum): string => {
  switch (strategy) {
    case 'self':
      return 'categorical-2'

    case 'manager':
      return 'categorical-6'

    case 'direct_reports':
      return 'categorical-5'

    case 'peers':
      return 'categorical-3'

    default:
      return 'categorical-9'
  }
}
